import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import styles from "./TaskAssignNew.module.css";
import CategoryAutocomplete from "./CategoryAutocomplete";
import { isActiveStaff } from "../../utils/contractEnded";



export default function TaskAssignNew() {
  const navigate = useNavigate();

  const [employees, setEmployees] = useState([]);
  const [categories, setCategories] = useState([]); // ✅ 카테고리 목록 상태 추가
  const [form, setForm] = useState({
    title: "",
    assignee: "",
    // content 제거
    due_date: "",
    priority: 1,
    reason_process: "",
    reason_next: "",
    ref_form: "",
    ref_material: "",
    work_category: "", // ✅ 업무 종류 필드 추가
    difficulty: 5,  // ✅ 업무 난이도 필드 추가 (기본값 5)
    est_hours: 0,   // ✅ 소요 시간(시)
    est_minutes: 0, // ✅ 소요 시간(분)
  });
  const [contentLines, setContentLines] = useState([""]);


  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const [dueDate, setDueDate] = useState("");
  const [ampm, setAmpm] = useState("오전");
  const [dueTime, setDueTime] = useState("09:00");

  const [myRank, setMyRank] = useState(null);
  const [newCatName, setNewCatName] = useState("");
  const [showCatAdd, setShowCatAdd] = useState(false);

  const TIMES = {
    오전: ["09:00", "09:30", "10:00", "10:30", "11:00", "11:30"],
    오후: ["12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00"],
  };

  // ← 추가
  const handleLineChange = (idx, value) => {
    setContentLines(prev => prev.map((l, i) => i === idx ? value : l));
  };
  const addLine = () => setContentLines(prev => [...prev, ""]);
  const removeLine = (idx) => {
    setContentLines(prev => prev.length === 1 ? [""] : prev.filter((_, i) => i !== idx));
  };

  useEffect(() => {
    api.get("/users/users/")
      .then((res) => {
        const raw = Array.isArray(res.data) ? res.data : (res.data.results || []);
        const list = raw.filter((emp) =>
          emp.name &&
          isActiveStaff(emp) &&   // 계약종료 제외(서버 판정 — 이름 문자열 판정 폐기)
          !emp.name.includes("테스트")
        );
        setEmployees(list);
      })
      .catch(() => setEmployees([]));

    // ✅ 백엔드에서 진짜 업무 종류 목록 가져오기 (예: /tasks/types/)
    api.get("/tasks/types/")
      .then((res) => {
        const raw = Array.isArray(res.data) ? res.data : (res.data.results || res.data.data || []);
        setCategories(raw);
      })
      .catch(() => setCategories([]));

    // ✅ 본인 권한(rank) 가져오기
    api.get("/users/me/")
      .then((res) => setMyRank(res.data.position_rank))
      .catch(() => setMyRank(null));

  }, []);



  const handleChange = (e) => {


    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleStar = (n) => {
    setForm((prev) => ({ ...prev, priority: n }));
  };

  const handleAddCategory = async () => {
    const name = newCatName.trim();
    if (!name) return;
    try {
      const res = await api.post("/tasks/types/", { name });
      setCategories((prev) => [...prev, res.data]);
      setForm((prev) => ({ ...prev, work_category: res.data.id }));  // 추가하자마자 선택
      setNewCatName("");
      setShowCatAdd(false);
    } catch (err) {
      alert(err.response?.data?.detail || "추가 실패");
    }
  };

  const handleDeleteCategory = async (id) => {
    if (!window.confirm("이 업무 종류를 삭제할까요?")) return;
    try {
      await api.delete(`/tasks/types/${id}/`);
      setCategories((prev) => prev.filter((c) => c.id !== id));
      setForm((prev) =>
        String(prev.work_category) === String(id) ? { ...prev, work_category: "" } : prev
      );
    } catch (err) {
      alert(err.response?.data?.detail || "삭제 실패");
    }
  };


  const handleSubmit = async () => {
    // 1. 필수 입력 항목 검증 (alert 팝업 처리)
    if (!form.title) {
      alert("업무 제목을 입력해주세요.");
      return;
    }
    if (!form.assignee) {
      alert("수신자를 선택해주세요.");
      return;
    }
    
    // 업무 종류 미선택 검증 추가
    if (!form.work_category) {
      alert("업무 종류를 선택해주세요.");
      return;
    }

    // 예상 소요 시간 0시간 0분 검증 추가
    const hours = Number(form.est_hours) || 0;
    const minutes = Number(form.est_minutes) || 0;
    if (hours === 0 && minutes === 0) {
      alert("예상 소요 시간을 선택해주세요.");
      return;
    }

    if (!contentLines.some(l => l.trim())) {
      alert("업무 내용을 입력해주세요.");
      return;
    }
    if (!dueDate) {
      alert("업무 기한을 선택해주세요.");
      return;
    }

    // 2. 데이터 가공
    const combinedDueDate = `${dueDate}T${dueTime}:00`;

    // 빈 줄을 먼저 제외(filter)한 후에 번호(1., 2.)를 매깁니다.
    const combinedContent = contentLines
      .filter(l => l.trim())
      .map((l, i) => `${i + 1}. ${l}`)
      .join("\n");

    setError("");
    setSubmitting(true);

    try {
      // difficulty 값을 정수형으로 변환 및 총 소요 시간(분) 계산
      const payload = {
        ...form,
        content: combinedContent,
        due_date: combinedDueDate,
        difficulty: Number(form.difficulty) || 5,
        est_minutes: (hours * 60) + minutes, // 위에서 계산한 변수 활용
      };

      await api.post("/tasks/", payload);
      alert("업무 지시가 전송되었습니다.");
      navigate("/task/assign/list");
    } catch (err) {
      setError("전송 중 오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      setSubmitting(false);
    }
  };


  const starDescs = ["", "★ 보통 — 기한 내 처리", "★★ 긴급 — 우선 처리 요망", "★★★ 매우 긴급 — 즉시 처리 필요"];



  return (
    <div className={styles.wrap}>
      <div className={styles.panel}>
        <div className={styles.panelTitle}>
          업무 지시 작성 <span className={styles.badge}>신규</span>
        </div>

        {/* 기본 정보 */}
        <div className={styles.section}>
          <div className={styles.sectionLabel}>기본 정보</div>

          <div style={{ marginBottom: 12 }}>
            <div className={styles.fieldLabel}>업무 제목</div>

            <input
              type="text"
              name="title"
              value={form.title}
              onChange={handleChange}
              placeholder="업무를 한 줄로 요약해주세요"
              className={`${styles.input} ${styles.titleInput}`}
            />



          </div>

          <div className={styles.row3}>

            {/* 수신자 */}
            <div>
              <div className={styles.fieldLabel}>수신자 (담당자)</div>
              <select
                name="assignee"
                value={form.assignee}
                onChange={handleChange}
                className={styles.inputSmall}
              >
                <option value="">-- 선택 --</option>
                {employees.map((emp) => (
                  <option key={emp.id} value={emp.id}>
                    {emp.name} ({emp.position || ""})
                  </option>
                ))}
              </select>
            </div>

            {/* 업무 기한 */}
            <div>
              <div className={styles.fieldLabel}>업무 기한</div>
              <div className={styles.dueDateStack}>

                <div className={styles.dateWrap}>
                  <input
                    type="date"
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                    className={`${styles.input} ${styles.dateInput}`}
                  />
                  {!dueDate && (
                    <span className={styles.datePlaceholder}>년-월-일</span>
                  )}
                </div>




                <div className={styles.dueDateAmpm}>
                  {["오전", "오후"].map((v) => (
                    <button
                      key={v}
                      type="button"
                      onClick={() => { setAmpm(v); setDueTime(TIMES[v][0]); }}
                      style={{
                        padding: "7px 18px", borderRadius: 6, fontSize: 13, cursor: "pointer",


                        border: ampm === v ? "1px solid #25b765" : "1px solid #d0d7de",
                        background: ampm === v ? "#e8f5ea" : "#fff",
                        color: ampm === v ? "#1a6b1a" : "#555",
                        fontWeight: ampm === v ? 700 : 400,
                        whiteSpace: "nowrap",
                        marginBottom: 8
                      }}
                    >
                      {v}
                    </button>
                  ))}
                </div>
                <select
                  value={dueTime}
                  onChange={(e) => setDueTime(e.target.value)}
                  style={{
                    padding: "5px 6px", borderRadius: 6,
                    border: "1px solid #d0d7de", background: "#f9fafb",
                    color: "#222", cursor: "pointer", width: "80px",
                    marginBottom: 8
                  }}
                >
                  {TIMES[ampm].map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </div>
              <div className={styles.fieldHint}>수정·검토 시간을 고려하여 선택하세요</div>
            </div>


            {/* 업무 긴급도 */}
            <div>
              <div className={styles.fieldLabel}>업무 긴급도</div>


              <div className={styles.starRow}>
                {[1, 2, 3].map((n) => (
                  <button
                    key={n}
                    type="button"
                    className={`${styles.star} ${form.priority === n ? styles.starOn : ""}`}
                    onClick={() => handleStar(n)}
                  >
                    {"★".repeat(n)}{"☆".repeat(3 - n)}
                  </button>
                ))}
              </div>
              <div className={styles.fieldHint}>{starDescs[form.priority]}</div>
            </div>

          </div>

          {/* ✅ 업무 종류 및 난이도 입력 행 추가 */}
          <div className={styles.row2} style={{ marginTop: 14 }}>
            <div>
              <div className={styles.fieldLabel}>업무 종류</div>

              <div className={styles.catWrap}>
                <CategoryAutocomplete
                  categories={categories}
                  value={form.work_category}
                  onChange={(id) => setForm((prev) => ({ ...prev, work_category: id }))}
                />
              </div>







              {/* ✅ 관리자급(rank 3 이하)만 종류 추가/관리 */}
              {myRank !== null && myRank <= 3 && (
                <div style={{ marginTop: 6 }}>
                  {!showCatAdd ? (
                    <button
                      type="button"
                      onClick={() => setShowCatAdd(true)}
                      style={{
                        fontSize: 12, color: "#4361ee", background: "none",
                        border: "none", cursor: "pointer", padding: 0
                      }}
                    >
                      + 업무 종류 추가/관리
                    </button>
                  ) : (
                    <div>

                      <div style={{ display: "flex", gap: 6, marginBottom: 6, alignItems: "center" }}>

                        <input
                          type="text"
                          className={styles.newCatInput}
                          value={newCatName}
                          onChange={(e) => setNewCatName(e.target.value)}
                          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleAddCategory(); } }}
                          placeholder="새 업무 종류"
                          style={{
                            width: 160, height: 34, padding: "0 10px", boxSizing: "border-box",
                            border: "1px solid #d0d7de", borderRadius: 6, fontSize: 13
                          }}
                        />


                        <button type="button" onClick={handleAddCategory}
                          style={{
                            width: 56, height: 34, fontSize: 13, boxSizing: "border-box",
                            background: "#4361ee", color: "#fff", border: "none",
                            borderRadius: 6, cursor: "pointer", whiteSpace: "nowrap"
                          }}>추가</button>
                        <button type="button" onClick={() => { setShowCatAdd(false); setNewCatName(""); }}
                          style={{
                            width: 56, height: 34, fontSize: 13, boxSizing: "border-box",
                            background: "#f0f0f0", color: "#666", border: "1px solid #d0d7de",
                            borderRadius: 6, cursor: "pointer", whiteSpace: "nowrap"
                          }}>닫기</button>
                      </div>



                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                        
                        {categories.map((cat) => (
                          <span key={cat.id} style={{
                            fontSize: 12, background: "#f0f0f0",
                            borderRadius: 4, padding: "4px 8px", display: "inline-flex",
                            alignItems: "center", gap: 6, whiteSpace: "nowrap"
                          }}>
                            {cat.name}
                            <button type="button" onClick={() => handleDeleteCategory(cat.id)}
                              style={{
                                background: "none", border: "none", color: "#c00",
                                cursor: "pointer", padding: 0, fontSize: 14, lineHeight: 1
                              }}>×</button>
                          </span>
                        ))}


                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className={styles.diffTimeWrap}>
              <div>
                <div className={styles.fieldLabel}>업무 난이도 (1 ~ 10)</div>


                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>

                  <input
                    type="number"
                    name="difficulty"
                    min="1"
                    max="10"
                    value={form.difficulty}
                    onChange={handleChange}
                    className={styles.inputMini}
                  />
                  <span style={{ fontSize: 13, color: "#666", whiteSpace: "nowrap" }}>/ 10 점</span>
                </div>


              </div>

              <div>
                <div className={styles.fieldLabel}>예상 소요 시간</div>


                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <select
                    name="est_hours"
                    value={form.est_hours}
                    onChange={handleChange}
                    style={{
                      height: 38, padding: "0 8px", boxSizing: "border-box",
                      border: "1px solid #d0d7de", borderRadius: 6, fontSize: 14, cursor: "pointer"
                    }}
                  >
                    {Array.from({ length: 9 }, (_, h) => (
                      <option key={h} value={h}>{h}</option>
                    ))}
                  </select>
                  <span style={{ fontSize: 13, color: "#666", whiteSpace: "nowrap" }}>시간</span>


                  <select
                    name="est_minutes"
                    value={form.est_minutes}
                    onChange={handleChange}
                    style={{
                      height: 38, padding: "0 8px", boxSizing: "border-box",
                      border: "1px solid #d0d7de", borderRadius: 6, fontSize: 14, cursor: "pointer"
                    }}
                  >
                    {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].map((m) => (

                      <option key={m} value={m}>{m}</option>
                    ))}
                  </select>
                  <span style={{ fontSize: 13, color: "#666", whiteSpace: "nowrap" }}>분</span>

                </div>
              </div>
            </div>


          </div>

        </div>

        {/* 업무 내용 ← 변경 */}


        <div className={styles.section}>
          <div className={styles.sectionLabel}>업무 내용</div>
          {contentLines.map((line, idx) => (
            <div key={idx} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
              <span style={{ fontSize: 13, color: "#888", fontWeight: 700, minWidth: 20 }}>
                {idx + 1}.
              </span>
              <input
                type="text"
                value={line}
                onChange={(e) => handleLineChange(idx, e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") { e.preventDefault(); addLine(); }
                }}
                placeholder={`업무 내용 ${idx + 1}`}
                className={styles.input}
                style={{ flex: 1 }}
              />
              <button
                type="button"
                onClick={() => removeLine(idx)}
                style={{
                  background: "none", border: "none", color: "#ccc",
                  fontSize: 18, cursor: "pointer", lineHeight: 1,
                  padding: 0, width: 24, flexShrink: 0
                }}
              >×</button>
            </div>
          ))}
          <button
            type="button"
            onClick={addLine}
            style={{
              marginTop: 4, fontSize: 14, color: "#4361ee", background: "none",
              border: "1px dashed #050505", borderRadius: 6,
              padding: "4px 14px", cursor: "pointer", width: "fit-content"
            }}
          >
            + 항목 추가
          </button>
        </div>

        {/* 업무 이유 */}
        <div className={styles.section}>
          <div className={styles.sectionLabel}>업무 이유</div>
          <div className={styles.subSection}>
            <div className={styles.subLabel}>앞/뒤 프로세스 설명</div>
            <textarea
              name="reason_process"
              value={form.reason_process}
              onChange={handleChange}
              placeholder="이 업무가 전체 흐름에서 어느 위치인지, 앞뒤로 어떤 업무와 연결되는지 설명해주세요"
              className={styles.textarea}
            />
          </div>
          <div className={styles.subSection}>
            <div className={styles.subLabel}>뒷사람 입장 설명</div>
            <textarea
              name="reason_next"
              value={form.reason_next}
              onChange={handleChange}
              placeholder="이 업무 결과를 받는 다음 담당자 입장에서 어떤 점이 중요한지 설명해주세요"
              className={styles.textarea}
            />
          </div>
        </div>

        {/* 업무 방법 */}
        <div className={styles.section}>
          <div className={styles.sectionLabel}>업무 방법</div>
          <div className={styles.subSection}>
            <div className={styles.subLabel}>참고 양식</div>
            <input
              type="text"
              name="ref_form"
              value={form.ref_form}
              onChange={handleChange}
              placeholder="사용할 양식명 또는 파일명을 입력하세요"
              className={styles.input}
            />
          </div>
          <div className={styles.subSection}>
            <div className={styles.subLabel}>참고 자료</div>
            <input
              type="text"
              name="ref_material"
              value={form.ref_material}
              onChange={handleChange}
              placeholder="관련 문서, URL, 파일명 등을 입력하세요"
              className={styles.input}
            />
          </div>
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <div className={styles.btnRow}>
          <button
            type="button"
            className={styles.btnCancel}
            onClick={() => navigate(-1)}
          >
            취소
          </button>
          <button
            type="button"
            className={styles.btnSubmit}
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? "전송 중..." : "업무 지시 전송"}
          </button>
        </div>

      </div>
    </div>
  );
}